<template>
  <v-card class="pt-0 pl-2 pb-2 pa-2" width="100%" outlined>
    <v-card-title>
      <v-row>
        <v-col cols="2">
          Titulo de tarjeta:
        </v-col>
        <v-col cols="9">
          <v-text-field v-model="cardTitle" :rules="requiredRule"/>
        </v-col>
        <v-btn text @click="removeCard" fab>X</v-btn>
      </v-row>
    </v-card-title>
    <v-card-text width="100%" height="100%">
      <slot ref="card" v-bind:title="cardTitle" />
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props:{
    cardTitleProp:{
      type:String
    },
    idCard:{
      type:Number
    }
  },
  data(){
    return {
      cardTitle: undefined,
      requiredRule: [
        v => !!v || 'Este campo es obligatorio.'
      ],
    }
  },
  mounted(){
    if(this.cardTitleProp!==''){
      this.cardTitle = this.cardTitleProp
    }
  },
  methods:{
    removeCard(){
      this.$emit('deleteThisCard',this.idCard)
    }
  }
}
</script>